module.exports = __webpack_public_path__ + "img/close.60bd004f.svg";